"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentDetailsTypeValues = exports.PaymentDetailsType = void 0;
var PaymentDetailsType;
(function (PaymentDetailsType) {
    PaymentDetailsType["CARD"] = "card";
    PaymentDetailsType["PAYPAL"] = "paypal";
    PaymentDetailsType["MONOBANK_ACCUMULATION"] = "mono-accumulation";
    PaymentDetailsType["IBAN"] = "iban";
    PaymentDetailsType["CRYPTO"] = "crypto";
    PaymentDetailsType["NONE"] = "none";
})(PaymentDetailsType = exports.PaymentDetailsType || (exports.PaymentDetailsType = {}));
exports.PaymentDetailsTypeValues = [
    PaymentDetailsType.CARD,
    PaymentDetailsType.PAYPAL,
    PaymentDetailsType.MONOBANK_ACCUMULATION,
    PaymentDetailsType.IBAN,
    PaymentDetailsType.CRYPTO,
    PaymentDetailsType.NONE,
];
